import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {holderProfileSelector, profileSettingsSelector} from '../../../redux/selectors/profile';

export const DesktopProfile: React.FC = () => {
  const holderProfile = useSelector(holderProfileSelector());
  const profileSettings = useSelector(profileSettingsSelector());

  return <View holderProfile={holderProfile} profileSettings={profileSettings} />;
};
